import { WebView } from 'cc';

declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface WebView {
        /**
         * update the src of webview cleanly to avoid window.history pollution
         * @param url new url
         */
        updateSrcCleanly(url: string): void;
    }
}

if (WebView) {
    WebView.prototype.updateSrcCleanly = function updateSrcSafely(this: WebView, url: string) {
        if (this.url === url) {
            return;
        }
        const parent = this.nativeWebView?.parentElement;
        if (parent) {
            parent.removeChild(this.nativeWebView);
            this.url = url;
            parent.appendChild(this.nativeWebView);
        } else {
            this.url = url;
        }
    };
}
